import { inject, Injectable } from '@angular/core';
import { LocaleLanguage } from '@app/+authenticated/shared/locale/locale.helper';
import { TranslateService } from '@ngx-translate/core';
import { FeatureService } from '@sb/shared/feature';
import { SbDialogService } from '@sb/ui/dialog';

import { ArcadeDemoDialogComponent, ArcadeDemoDialogData } from './arcade-demo-dialog.component';
import { ARCADE_DEMOS, DemoType, isSupportedLanguageDemo } from './demo-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class DemoDialogService {
  private dialogService = inject(SbDialogService);
  private translateService = inject(TranslateService);
  private featureService = inject(FeatureService);

  openDemo(demoType: DemoType) {
    const demos = ARCADE_DEMOS[demoType];
    const language = this.translateService.getCurrentLang();
    const demoId =
      (language && isSupportedLanguageDemo(language) ? demos[language] : undefined) ?? demos[LocaleLanguage.ENGLISH];

    return this.dialogService
      .setSize('fullscreen')
      .open<ArcadeDemoDialogComponent, ArcadeDemoDialogData>(ArcadeDemoDialogComponent, {
        data: { demoId },
      }).closed;
  }
}
